import productionNaturalWaterPool from "../abis/production/pools/naturalWaterPool";

const host = "https://bscscan.com/address";

export default [
  {
    title: "Natural Water Pool",
    contractAddress: "0xc66d6afac26dfaf896765c7210dd6eaca8becd5b",
    minApr: 159,
    abi: productionNaturalWaterPool.abi,
    url: `${host}/0xc66d6afac26dfaf896765c7210dd6eaca8becd5b`,
  },
];

// PooL Staking

// Name：Natural water Pool
// *Auto Compound

// Stake. SAUNA
// Earn. SAUNA
// Total Reword Token:  920k (SAUNA)
// Start Time: now
// Bonus End Time:now→1825days
// Min. SAUNA Token:  No specification
// Max. Total SAUNA Token:  No specification
// Unstake time lock. 30days
// Unstake Fee. 30%
// Destination for Unstake Fee. (BNB-SAUNA) liquidity
